<app-entity-onboard [content]="content" (formValues)="setFormValues($event)"></app-entity-onboard>